import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { SelectionComponent } from './selection/selection.component';
import { MainComponent } from './main/main.component';
import { StandardComponent } from './layout/standard/standard.component';
import { HomeComponent } from './dashboard/home/home.component';

import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard'
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { GedcomComponent } from './dashboard/gedcom/gedcom.component';
import { SelectionComponent } from './dashboard/selection/selection.component';
import { OrdersComponent } from './dashboard/orders/orders.component';
import { DesignsComponent } from './dashboard/designs/designs.component';
import { ProfileComponent } from './dashboard/profile/profile.component';
import { TreeCheckGuard } from './components/modal/tree-check.guard';
import { NewsComponent } from './dashboard/news/news.component';
import { OrderConfirmationComponent } from './service/order-confirmation/order-confirmation.component';
import { AssistancePackageComponent } from './dashboard/assistance-package/assistance-package.component';
import { WizardComponent } from './components/wizard/wizard.component';
// import { AdminOrdersComponent } from './admin-orders/admin-orders.component';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['sign-in']);
const routes: Routes = [
  { path: 'sign-in', component: SignInComponent },
  { path: 'register-user', component: SignUpComponent },
  // { path: 'admin-orders', component: AdminOrdersComponent}, 
  { path: 'order-confirmation', component: OrderConfirmationComponent },
  {
    path: 'wizard', component: WizardComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
  },
  {
    path: 'dashboard',
    component: StandardComponent,
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectUnauthorizedToLogin },
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'selection', component: SelectionComponent },
      { path: 'gedcom', component: GedcomComponent },
      { path: 'orders', component: OrdersComponent },
      { path: 'designs', component: DesignsComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'assistance-package', component: AssistancePackageComponent },
      { path: 'news', component: NewsComponent },
      { path: 'main', component: MainComponent, canDeactivate: [TreeCheckGuard] },
    ]
  },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'verify-email-address', component: VerifyEmailComponent },
  // { path: 'selection', component: SelectionComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } }, // Webb app route
  { path: 'main', component: MainComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } }, // Webb app route
  {
    path: "**",
    redirectTo: "/dashboard/home"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
